import { useSyncExternalStore } from "react";

/**
 * A counter bumped whenever something jumps the time cursor and wants the
 * sidebar's list scrolled back onto it — see `recenterToken` in `Stacks.tsx`,
 * which needs a signal separate from the interval itself because a preset can
 * land on the row the list is already showing (pressing "Today" while on today
 * but scrolled away) without changing `it` or `n`.
 *
 * A store rather than state in `StacksVertical` because the caller left that
 * subtree: `QuickIntervals` now sits in the header, on the other side of the
 * `Outlet` from the sidebar it re-centres. Deliberately not in Redux — it is a
 * one-shot signal, not state anything reads.
 */
let token = 0;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getToken() {
  return token;
}

export function requestStacksRecenter() {
  token += 1;
  listeners.forEach((listener) => listener());
}

export function useStacksRecenter() {
  return useSyncExternalStore(subscribe, getToken);
}
